<script setup lang="ts">
import { PromotionsAlertProps } from "./PromotionsAlert.props"
import { customPaths } from "~/utils/constants"

const props = defineProps<PromotionsAlertProps>()
</script>

<template>
  <div
    class="
      bottom-header
      padded
      from-green-main
      to-green-30
      text-white
      flex
      items-center
      bg-gradient-to-r
      py-4
    "
  >
    <UtilsIcon
      fetch-priority="high"
      :preload="true"
      name="Flash.svg"
      color="white"
      class="
        border-white
        bg-orange-main
        mr-4
        h-[40px]
        w-[40px]
        rounded-full
        border-2
        p-[7.5px]
      "
    />

    <div>
      <p class="dolphin-bold">
        {{ $t("brand.promotions.label", { brandName: brand }) }}
      </p>
      <AppLink :to="customPaths.promotions" class="mouse-medium underline">
        {{ $t("brand.promotions.ctaText") }}
      </AppLink>
    </div>
  </div>
</template>
